import { Box, styled } from '@mui/material';

export const SectionsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  paddingBottom: theme.spacing(6),
  marginBottom: theme.spacing(-6),

  [theme.breakpoints.up('lg')]: {
    paddingBottom: theme.spacing(3),
    marginBottom: theme.spacing(-3),
  },
}));
